import type { PixelSprite } from '../types.js';
const variant0: PixelSprite = {
  layers: [
    {
      paint: 'coral',
      d: 'M-1,-5.5h1v0.5h-1zM-1,-5h2.5v0.5h-2.5zM-2,-4.5h1v1h-1zM-0.5,-4.5h1.5v0.5h-1.5zM1.5,-4.5h0.5v0.5h-0.5zM-3.5,-4h1v0.5h-1zM-0.5,-4h1v1.5h-1zM1.5,-4h2v1h-2zM-3.5,-3.5h2.5v0.5h-2.5zM-3,-3h2v0.5h-2zM1,-3h2v0.5h-2zM-3,-2.5h5.5v0.5h-5.5zM-2.5,-2h4.5v0.5h-4.5zM-2,-1.5h3.5v0.5h-3.5zM-1,-1h2v1.5h-2z',
    },
  ],
  pixels: 83,
};
export const sprites: readonly PixelSprite[] = [variant0, variant0, variant0];
